import { useEffect, useState } from 'react';
import { Res } from '@cbo/shared-library';
import Box from '@mui/material/Box';
import CompanyLinksTable from './CompanyLinksTable/CompanyLinksTable';
import CreateEditCompanyLinkForm from './CreateEditCompanyLinkForm/CreateEditCompanyLinkForm';
import { TViewersSetting } from '../../models/config/viewers';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { cboRoleToLegacyRoleNames } from '../../services/LinkService';

// TODO: These to maps are a weird way to leave the role to link auth the same
export enum LinkRole {
  ABOVE_STORE_MANAGER_LINK_VIEWER = 'CBO_ABOVE_STORE_MANAGER_LINK_VIEWER',
  ASSISTANT_MANAGER_LINK_VIEWER = 'CBO_ASSISTANT_MANAGER_LINK_VIEWER',
  EMPLOYEE_LINK_VIEWER = 'CBO_EMPLOYEE_LINK_VIEWER',
  ADMIN_LINK_VIEWER = 'CBO_ADMIN_LINK_VIEWER',
  SUPPORT_LINK_VIEWER = 'CBO_SUPPORT_LINK_VIEWER',
  STORE_MANAGER_LINK_VIEWER = 'CBO_STORE_MANAGER_LINK_VIEWER',
  ACCOUNTANT_LINK_VIEWER = 'CBO_ACCOUNTANT_LINK_VIEWER',
}

const roleLabels: Record<LinkRole, string> = {
  [LinkRole.ADMIN_LINK_VIEWER]: 'Administrator',
  [LinkRole.ASSISTANT_MANAGER_LINK_VIEWER]: 'Assistant Manager',
  [LinkRole.EMPLOYEE_LINK_VIEWER]: 'Employee',
  [LinkRole.SUPPORT_LINK_VIEWER]: 'NCR Support',
  [LinkRole.ABOVE_STORE_MANAGER_LINK_VIEWER]: 'Above Store Manager',
  [LinkRole.STORE_MANAGER_LINK_VIEWER]: 'Restaurant manager',
  [LinkRole.ACCOUNTANT_LINK_VIEWER]: 'Accountant/Bookkeeper',
};

function EditLinksPage() {
  const [isCreatingOrEditingLink, setIsCreatingOrEditingLink] = useState<boolean>(false);
  const [roles, setRoles] = useState<TViewersSetting[]>([]);
  const [linkToEdit, setLinkToEdit] = useState<Res.Firebase.Link>();
  const [areRolesLoading, setAreRolesLoading] = useState<boolean | null>(null);
  const { setSnackbarState } = useSnackbar();

  const setIsCreatingOrEditingLinkFunction = (value: boolean) => {
    if (!value) {
      setLinkToEdit(undefined);
    }
    setIsCreatingOrEditingLink(value);
  };

  useEffect(() => {
    const fetchAllRoles = async () => {
      try {
        setAreRolesLoading(true);
        const mappedRoleData: TViewersSetting[] = Object.values(LinkRole).map((role) => ({
          id: cboRoleToLegacyRoleNames[role],
          label: roleLabels[role],
        }));

        mappedRoleData.unshift({
          id: 'Everyone',
          label: 'Everyone',
        });

        setRoles(mappedRoleData);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        setAreRolesLoading(false);
      }
    };
    fetchAllRoles();
  }, [setSnackbarState]);

  return (
    <Box>
      {isCreatingOrEditingLink ? (
        <CreateEditCompanyLinkForm
          setIsCreatingOrEditingLink={setIsCreatingOrEditingLinkFunction}
          areRolesLoading={areRolesLoading}
          viewers={roles}
          linkToEdit={linkToEdit}
        />
      ) : (
        <Box>
          <CompanyLinksTable
            setIsCreatingOrEditingLink={setIsCreatingOrEditingLinkFunction}
            setLinkToEdit={setLinkToEdit}
          />
        </Box>
      )}
    </Box>
  );
}

export default EditLinksPage;
